import styled from 'styled-components';

import { sizeDown } from '~/theme';

export const ProductName = styled.div(({ theme }) => ({
  color: theme.palette.darkLiver,
  fontSize: '16rem',
  marginBottom: '10rem',
}));

export const ProductCost = styled.div(({ theme }) => ({
  color: theme.palette.darkLiver,
}));

export const ProductInfoContainer = styled.div({
  marginBottom: '15rem',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '70%',
  paddingLeft: '20rem',
  paddingRight: '20rem',
  minHeight: '46rem',
});

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  position: 'relative',
  padding: '1rem',
});

export const ImgContainer = styled.div({
  position: 'relative',
});

export const CarouselImage = styled.img({
  minHeight: '200rem',
  height: sizeDown('40vh', ['991rem', '35vh']),
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '70%',
  maxHeight: '100%',
  objectFit: 'contain',
  borderRadius: '8rem',
  padding: '20rem',
});

export const ThumbnailsContainer = styled.div({
  marginTop: '20rem',
  height: '70rem',
});

export const Thumbnail = styled.img(({ theme }) => ({
  maxWidth: '100rem',
  maxHeight: '70rem',
  padding: '5rem',
  objectFit: 'cover',
  margin: '0.5rem',
  cursor: 'pointer',
  opacity: '0.6',
  transition: 'opacity 0.3s ease-in-out',
  borderRadius: '4rem',

  '&[data-is-selected="true"]': {
    border: `3rem solid ${theme.palette.darkLiver}`,
  },

  '&:hover': {
    boxShadow: `0 3rem 6rem ${theme.palette.black}29`,
  },
}));
